import Vue from 'vue'
import App from './App.vue'
import router from './router'


import {BootstrapVue, IconsPlugin, DropdownPlugin, TablePlugin} from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// import ECharts from 'vue-echarts'
// import 'echarts/lib/chart/line'
// import "echarts/lib/chart/bar";
// import "echarts/lib/chart/candlestick";
// import 'echarts/lib/component/title'
// import "echarts/lib/component/dataZoom";
// import "echarts/lib/component/axis";
// import "echarts/lib/component/axisPointer";
// import "echarts/lib/component/tooltip";
// import "echarts/lib/component/toolbox";
// import "echarts/lib/component/legend";
// import "echarts/lib/component/markLine";
// import "echarts/lib/component/markPoint";
// import "echarts/lib/component/markArea";
// import "echarts/lib/component/timeline";
// import "echarts/lib/component/visualMap";

// Vue.component('v-chart', ECharts)

// import ECharts from 'vue-echarts' // 在 webpack 环境下指向 components/ECharts.vue
// 手动引入 ECharts 各模块来减小打包体积
// import 'echarts/lib/chart/bar'
// import 'echarts/lib/component/tooltip'
// 注册组件后即可使用
// Vue.component('v-chart', ECharts)

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(DropdownPlugin)
Vue.use(TablePlugin)

Vue.config.productionTip = false


router.beforeEach((to,fr,next) => {
	if(to.meta.title){
		document.title=to.meta.title
	}
	next()
})

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
 